var Glide = require('../node_modules/@glidejs/glide/dist/glide');

jQuery(document).ready( function($) {
	
	function initMap( $el ) {
		
		// Find marker elements within map.
		var $markers = $el.find('.marker');
		
		// Create gerenic map.
		var mapArgs = {
			zoom        : $el.data('zoom') || 16,
			mapTypeId   : google.maps.MapTypeId.ROADMAP
		};
		var map = new google.maps.Map( $el[0], mapArgs );
		
		// Add markers.
		map.markers = [];
		$markers.each(function(){
			initMarker( $(this), map );
		});
		
		// Center map based on markers.
		centerMap( map );
		
		// Return map instance.
		return map;
	}
	
	function initMarker( $marker, map ) {
		
		// Get position from marker.
		var lat = $marker.data('lat');
		var lng = $marker.data('lng');
		var latLng = {
			lat: parseFloat( lat ),
			lng: parseFloat( lng )
		};
		
		// Create marker instance.
		var marker = new google.maps.Marker({
			position : latLng,
			map: map
		});
		
		// Append to reference for later use.
		map.markers.push( marker );
		
		// If marker contains HTML, add it to an infoWindow.
		if( $marker.html() ){
			
			// Create info window.
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});
			
			// Show info window when marker is clicked.
			google.maps.event.addListener(marker, 'click', function() {
				infowindow.open( map, marker );
			});
		}
	}
	
	function centerMap( map ) {
		
		// Create map boundaries from all map markers.
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function( marker ){
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});
		
		// Case: Single marker.
		if( map.markers.length == 1 ){
			map.setCenter( bounds.getCenter() );
			
			// Case: Multiple markers.
		} else{
			map.fitBounds( bounds );
		}
	}
	
	if ( $('.ln-header-slides').length ) {
		new Glide('.ln-header-slides', {
			type: 'carousel',
			autoplay: 5000,
			startAt: 0,
			perView: 1
		}).mount();
	}
	
	if ( $('.ln-event-slides').length ) {
		new Glide('.ln-event-slides', {
			type: 'carousel',
			autoplay: 10000,
			startAt: 0,
			perView: 1
		}).mount();
	}
	
	if ( $('.ln-news-slides').length ) {
		new Glide('.ln-news-slides', {
			type: 'carousel',
			autoplay: 15000,
			startAt: 0,
			perView: 1
		}).mount();
	}
	
	if ( $('.ln-offer-slides').length ) {
		new Glide('.ln-offer-slides', {
			type: 'carousel',
			autoplay: 5000,
			startAt: 0,
			perView: 3,
			breakpoints: {
				1200: {
					perView: 3
				},
				991: {
					perView: 2
				},
				500: {
					perView: 1,
					bound: true,
				}
			}
		}).mount();
	}
	
	$('[data-toggle="offcanvas"], #navToggle').on('click', function () {
		$('.offcanvas-collapse').toggleClass('open')
	});
	
	$('#navClose').on('click', function () {
		$('.offcanvas-collapse').toggleClass('open')
	});
	
	$('.filter-link').on('click', function(e) {
		e.preventDefault();
		if ( $('.lockdown-row').length ) {
			$('.lockdown-row').hide();
			var filterID = $(this).attr('href');
			$('.lockdown-row[data-filter="'+filterID.replace('#', '')+'"]').show();
		} else {
			$('.ln-directory-box').hide();
			var filterID = $(this).attr('href');
			$('.ln-directory-box[data-filter="'+filterID.replace('#', '')+'"]').show();
		}
	});
	
	$('.acf-map').each(function(){
		var map = initMap( $(this) );
	});
	
	if ( $('div[data-event-start]').length ) {
		
		var eventStartArray = [];
		var eventEndArray = [];
		
		var eventStarts = $('div[data-event-start]').map(function() { eventStartArray.push($(this).attr('data-event-start')) });
		var eventEnds = $('div[data-event-end]').map(function() { eventEndArray.push($(this).attr('data-event-end')) });
		
		console.log('Start dates: '+eventStartArray);
		console.log('End dates: '+eventEndArray);
		
		function dateRange(startDate, endDate) {
			var start      = startDate.split('/');
			var end        = endDate.split('/');
			var startYear  = parseInt(start[0]);
			var endYear    = parseInt(end[0]);
			var dates      = [];
			var datesEnd   = [];
			
			var buttons = '';
			
			for(var i = startYear; i <= endYear; i++) {
				var endMonth = i != endYear ? 11 : parseInt(end[1]) - 1;
				var startMon = i === startYear ? parseInt(start[1])-1 : 0;
				for(var j = startMon; j <= endMonth; j = j > 12 ? j % 12 || 11 : j+1) {
					var month = j+1;
					var displayMonth = month < 10 ? '0'+month : month;
					dates.push([i, displayMonth, '01'].join('/'));
				}
			}
			datesEnd = dates.map(function(date) {
				date = new Date(date);
				var newDate = new Date(date.setMonth(date.getMonth()+1));
				return (newDate.getFullYear().toString()) + '/' + ((newDate.getMonth().toString() < 10) ? '0' + newDate.getMonth().toString() : newDate.getMonth().toString()) + '/' + ((newDate.getDay().toString() < 10) ? '0' + newDate.getDay().toString() : newDate.getDay().toString());
			});
			console.log('Months in between: '+dates);
			console.log('Months in between end: '+datesEnd);
			console.log(new Date(new Date(datesEnd[datesEnd.length -1]) - 1));
			var monthNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
			for ( d = 0; d < dates.length; d++ ) {
				convertedDate = new Date(dates[d]);
				buttons += '<a href="#" data-event-filter="'+dates[d]+'" class="btn btn-sm btn-primary">'+(monthNames[convertedDate.getMonth()])+' '+(convertedDate.getFullYear())+'</a>';
			}
			
			$('.ln-filter-wrapper').html(buttons);
			
		}
		
		dateRange(eventStartArray[0], eventEndArray[eventEndArray.length - 1]);
		
		$('.ln-filter-wrapper .btn').on('click', function(e) {
			e.preventDefault();
			if ( new Date($(this).attr('data-event-filter')) >= new Date(dates[0]) ) {
				console.log('We have an event that starts after the beginning of the month');
			};
			if ( new Date($(this).attr('data-event-filter')) <= new Date(dates[dates.length - 1]) ) {
				console.log('We have an event that ends after the beginning of the month');
			};
		});
		
	}
	
	
	function uniqueValues(value, index, self) {
		return self.indexOf(value) === index;
	}
	
	if ( $('.ln-archive-filter').length ) {
		
		// var neededFilter = [];
		// var ourLetters = [];
		
		// neededFilter = $('.ln-directory-box').toArray().map(x => $(x).attr('data-filter').toString());
		// ourLetters = $('.filter-link').toArray().map(y => $(y).attr('href').replace('#', '').toString());
		
		// var uniqueFilter = neededFilter.filter(uniqueValues);
		
		// console.log(uniqueFilter, ourLetters);
		
		// console.log(ourLetters[25].indexOf(uniqueFilter));
		// console.log(ourLetters[5].indexOf(uniqueFilter));
		
		// for (var l = 0; l < ourLetters.length; l++) {
		// 	if ( ourLetters[l].indexOf(uniqueFilter) === -1 ) {
		// 		$('.filter-link[href="#'+ourLetters[l]+'"]').removeAttr('href');
		// 	}
		// }
		
		$('.filter-link').on('click', function(){
			if ( $('.ln-directory-box').is(':visible')) {
				$('.filter-items-error').html('');
			} else {
				$('.filter-items-error').html('<p>We have no businesses listed under this letter.</p>');
			}
		});
		
	}
	
	if ( $('#lnModal').length ) {

		if (!sessionStorage.getItem('firstVisit')) {
			$("#lnModal").modal("show");
			sessionStorage.setItem('firstVisit', '1');
		} 
		
	}

	if ( $('.ln-lockdown-biz').length ) {
		$('.lock-button').on('click', function(e) {
			$('.lockdown-more').hide();
			$('#lock'+$(this).attr('data-info')).show();
			console.log($(this).attr('data-info'));
		});
	}

	if ( $('#business_search_form').length ) {
		function searchBusinesses() {
			var searchValue = $('#business_search').val().toLowerCase();
			$('.lockdown-row').hide();
			$('.lockdown-more').hide();
			if ( searchValue === '' ) {
				$('.lockdown-row').show();
			} else {
				$('.lockdown-row[data-search*="'+searchValue.toLowerCase()+'"]').show();
			}
		}
		$('#business_search_form').on('submit', function(e) {
			e.preventDefault();
			searchBusinesses();
		});
		$('#business_search').on('keyup', function() {
			searchBusinesses();
		});
	}
	
});